import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { ApplicationsRoute } from "../../routing/IndividualRoutes";

export class ApplicationsPage extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumbs />
        <ApplicationsRoute />
      </Fragment>
    );
  }
}
